module.exports = __webpack_public_path__ + "img/weixin.08bd2492.png";